/*
 * Globals
 */
const activeClass = `is-active`;
const loadingClass = `is-loading`;
const noScroll = `no-scroll`;
const locale = window.Shopify.locale == 'ja' ? '/ja' : '';
const loadingOverlay = document.getElementById(`js-loading-overlay`);
const cartCount = document.querySelectorAll(`.js-cart-count`);
const cartMsg = document.getElementById(`js-cart-msg`);
const animatedLogo = document.getElementById(`js-lottie`);
const animatedLogoTrigger = document.getElementById(`js-animated-logo`);
let mql = window.matchMedia('(max-width: 1024px)');
let characterGlideInstance = new Glide(`#js-character-glide`, {
  type: `carousel`,
  dragThreshold: false,
  swipeThreshold: false,
  gap: 0,
  animationTimingFunc: `cubic-bezier(.77,0,.175,1)`,
  animationDuration: 1500,
});
let delay;

/*
 * Price Formatting Functions
 */
const formatMoney = (cents, format = '') => {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  // HTMLのdata-currency属性から通貨記号を取得
  const currencySymbol = document.body.getAttribute('data-currency') || '$';

  // 通貨記号に基づいてデフォルトフォーマットを決定
  let defaultFormat = `${currencySymbol}{{amount}}`;
  if (currencySymbol === '¥') {
    defaultFormat = `¥{{amount_no_decimals_with_comma_separator}}`;
  } else if (currencySymbol === '€') {
    defaultFormat = `{{amount_with_comma_separator}} €`;
  } else if (currencySymbol === '£') {
    defaultFormat = `£{{amount}}`;
  }

  const formatString = format || window.Shopify?.money_format || defaultFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return 0;

    // 日本円の場合は100で割らない（既に円単位で来ている）
    if (currencySymbol === '¥') {
      number = parseFloat(number).toFixed(precision);
    } else {
      number = (number / 100.0).toFixed(precision);
    }

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  if (!match) return formatString;

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      // 日本円の場合は通常の千の位区切りを使用
      if (currencySymbol === '¥') {
        value = formatWithDelimiters(cents, 0, ',', '.');
      } else {
        value = formatWithDelimiters(cents, 0, '.', ',');
      }
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/*
 * Lenis
 */
// const lenis = new Lenis();
// const raf = (time) => {
//   if (!lenis) return;
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// };

/*
 * GSAP
 */
const animateLogo = () => {
  if (!animatedLogoTrigger || mql.matches) return;
  gsap.fromTo(
    animatedLogoTrigger,
    {},
    {
      scrollTrigger: {
        trigger: animatedLogoTrigger,
        once: true,
        onEnter: triggerLottie,
      },
    }
  );
};

const triggerLottie = () => {
  if (!animateLogo) return;
  animatedLogo.play();
};

/*
 * Locale
 */
const setLocale = () => {
  const selectors = document.querySelectorAll(`.js-locale-selector`);
  if (!selectors.length) return;
  selectors.forEach((selector) => {
    selector.addEventListener(`click`, () => {
      document.getElementById(`locale-code`).value = selector.getAttribute(`lang`);
      document.getElementById(`localization_form_tag`).submit();
    });
  });
};

const toggleLocale = () => {
  const langSwitcher = document.querySelectorAll(`.js-lang-switcher`);
  if (!langSwitcher.length) return;
  langSwitcher.forEach((switcher) => {
    const trigger = switcher.querySelector(`.js-locale-toggle`);
    const target = switcher.querySelector(`.js-locale-options`);
    trigger.addEventListener(`click`, () => {
      if (target.classList.contains(activeClass)) {
        target.classList.remove(activeClass);
        trigger.classList.remove(activeClass);
      } else {
        target.classList.add(activeClass);
        trigger.classList.add(activeClass);
      }
    });
  });
};

/*
 * Homepage
 */
const filterProducts = () => {
  const filterBtns = document.querySelectorAll(`.js-product-filter`);
  const productGrid = document.getElementById(`js-product-grid`);
  if (!filterBtns.length) return;
  filterBtns.forEach((btn) => {
    btn.addEventListener(`click`, () => {
      let handle = btn.dataset.collection;
      // set active btn state
      if (btn.classList.contains(activeClass)) btn.classList.remove(activeClass);
      else {
        btn.classList.add(activeClass);
        filterBtns.forEach((siblingBtn) => {
          if (siblingBtn != btn) siblingBtn.classList.remove(activeClass);
        });
      }
      fetch(window.Shopify.routes.root + `collections/${handle}/products.json`, {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.products.length) {
            let output = ``;
            const currency = document.body.dataset.currency;
            const soldOutLabel = 'Sold out';
            const newLabel = 'New';
            const comingSoonLabel = 'Coming soon';
            data.products.forEach((product) => {
              output += `<div class="product-grid-item"><div class="product-grid-item__image">`;
              if (product.tags == 'Sold out')
                output += `<span class="[ product-grid-item__tag product-grid-item__tag--sold-out ]">${soldOutLabel}</span>`;
              if (product.tags == 'New')
                output += `<span class="[ product-grid-item__tag product-grid-item__tag--new ]">${newLabel}</span>`;
              if (product.tags == 'Coming soon')
                output += `<span class="[ product-grid-item__tag product-grid-item__tag--coming-soon ]">${comingSoonLabel}</span>`;
              output += `<a href="${locale}/products/${product.handle}"><img data-src="${product.images[0].src}" class="lazyload" alt="${product.title}" /></a>`;
              if (product.variants.length > 1)
                output += `<a href="${locale}/products/${product.handle}" title="View Product" class="[ btn btn--yellow ]">View Product</a>`;
              else
                output += `<button title="Add to Cart" data-id="${product.variants[0].id}" class="[ js-quick-add-cart ] [ btn btn--yellow ]">Add to Cart</button>`;
              const formattedPrice = formatMoney(product.variants[0].price);
              output += `</div><div><h2 class="product-grid-item__name">${product.title}</h2><span class="product-grid-item__price">${formattedPrice}</span></div></div>`;
            });
            productGrid.innerHTML = output;
          } else {
            productGrid.innerHTML = `<p>No products in this category!</p>`;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  });
};

/*
 * Accordion
 */
const accordion = () => {
  const tabs = document.querySelectorAll(`.js-accordion-tab`);
  if (!tabs.length) return;
  tabs.forEach((tab) => {
    tab.addEventListener(`click`, () => {
      if (tab.classList.contains(activeClass)) tab.classList.remove(activeClass);
      else {
        tab.classList.add(activeClass);
      }
    });
  });
};

/*
 * Product
 */
const gallery = () => {
  if (!document.getElementById(`js-gallery-glide`)) return;
  new Glide(`#js-gallery-glide`, {
    type: `carousel`,
    dragThreshold: false,
    gap: 0,
    animationDuration: 0,
    rewindDuration: 0,
  }).mount();
};

const setQuantity = () => {
  const qty = document.querySelectorAll(`.js-product-qty`);
  const cartForm = document.forms[`cart-form`];
  const submitForm = (currentVal, newValue) => {
    currentVal.value = newValue;
    currentVal.setAttribute(`value`, newValue);
    if (cartForm) cartForm.submit();
  };
  if (!qty.length) return;
  qty.forEach((q) => {
    const val = q.querySelector(`.js-product-qty-val`);
    const plus = q.querySelector(`.js-product-qty-plus`);
    const minus = q.querySelector(`.js-product-qty-minus`);
    let currentQty = val.value;
    minus.addEventListener(`click`, () => {
      if (currentQty <= 1) return;
      else currentQty--;
      submitForm(val, currentQty);
    });
    plus.addEventListener(`click`, () => {
      currentQty++;
      submitForm(val, currentQty);
    });
  });
};

const setSelectedVariant = () => {
  const variants = document.querySelectorAll(`.js-product-variant`);
  const addToCartButton = document.getElementById(`js-add-to-cart`);
  const productPrice = document.getElementById(`js-product-price`);
  if (!variants.length) return;

  // 商品バリエーションデータを取得（在庫情報付き）
  const productVariantsData = window.productVariantsWithInventory || window.productVariants || [];
  const stockThreshold = 0;

  // check URL param first
  let url = new URL(location.href);
  let params = new URLSearchParams(url.search);
  let variantIDURL = params.get(`variant`);

  // 在庫状況をチェックしてボタンを更新する関数
  const updateButtonState = (variantID) => {
    const selectedVariant = productVariantsData.find((v) => v.id == variantID);

    if (selectedVariant && addToCartButton) {
      const isOutOfStock = selectedVariant.inventory_quantity == stockThreshold;
      const isUnavailable = !selectedVariant.available;

      // 親コンテナ（quantity-selector）を取得
      const quantitySelectorContainer = addToCartButton.closest('.quantity-selector');

      if (isOutOfStock || isUnavailable) {
        // ボタンを無効化
        addToCartButton.disabled = true;
        addToCartButton.textContent = addToCartButton.dataset.soldOutText || 'Sold out';
        addToCartButton.classList.add('btn--disabled');

        // 親コンテナにis-disabledクラスを追加
        if (quantitySelectorContainer) {
          quantitySelectorContainer.classList.add('is-disabled');
        }
      } else {
        // ボタンを有効化
        addToCartButton.disabled = false;
        addToCartButton.textContent = addToCartButton.dataset.addToCartText || 'Add to cart';
        addToCartButton.classList.remove('btn--disabled');

        // 親コンテナからis-disabledクラスを削除
        if (quantitySelectorContainer) {
          quantitySelectorContainer.classList.remove('is-disabled');
        }
      }
    }
  };

  variants.forEach((variant) => {
    const variantID = variant.dataset.id;
    const variantPrice = variant.dataset.price;
    const stateHandler = () => {
      addToCartButton.dataset.id = variantID;
      addToCartButton.dataset.price = variantPrice;
      if (productPrice) productPrice.textContent = variantPrice;
      variant.classList.add(`is-selected`);
      params.set(`variant`, variantID);
      history.pushState(null, null, '?' + params.toString());
      variants.forEach((sibling) => {
        if (sibling != variant) sibling.classList.remove(`is-selected`);
      });

      // 在庫状況に基づいてボタンの状態を更新
      updateButtonState(variantID);
    };
    // set active variant based on URL param value
    if (variantIDURL == variantID) stateHandler();
    // user selection
    variant.addEventListener(`click`, (e) => {
      stateHandler();
    });
  });
};

const postRequestHandler = (btn) => {
  document.addEventListener(`click`, (e) => {
    let target = e.target.closest(btn);
    const qtyField = document.getElementById(`js-item-qty`);
    let qty = qtyField ? qtyField.value : 1;
    if (!target) return;
    // clear setTimeout
    clearTimeout(delay);
    // clear error message
    cartMsg.classList.remove(activeClass);
    // set loading state
    document.body.classList.add(loadingClass);
    loadingOverlay.classList.add(activeClass);
    target.classList.add(loadingClass);
    const requestBody = {
      items: [
        {
          id: parseInt(target.dataset.id),
          quantity: parseInt(qty),
        },
      ],
    };
    fetch(window.Shopify.routes.root + `cart/add.js`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        // remove loading state
        document.body.classList.remove(loadingClass);
        loadingOverlay.classList.remove(activeClass);
        target.classList.remove(loadingClass);
        cartMsg.classList.add(activeClass);
        delay = setTimeout(() => {
          cartMsg.classList.remove(activeClass);
        }, 3000);
        if (data.status == 422) {
          // display error message
          cartMsg.textContent = data.description;
          return;
        } else {
          // display success message
          cartMsg.textContent = window.cartTranslations.addedToCart;
          // update cart count
          cartCount.forEach((c) => {
            c.textContent = parseInt(c.textContent) + parseInt(qty);
          });
          return data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  });
};

// product page
const addToCart = () => {
  const btn = document.getElementById(`js-add-to-cart`);
  if (!btn) return;
  postRequestHandler(`#js-add-to-cart`);
};

// product grid item
const quickAddToCart = () => {
  const buttons = document.querySelectorAll(`.js-quick-add-cart`);
  if (!buttons.length) return;
  postRequestHandler(`.js-quick-add-cart`);
};

const toggleMobileOptions = () => {
  const optionLabels = document.querySelectorAll(`.js-product-option-label`);
  if (!optionLabels.length) return;
  optionLabels.forEach((option) => {
    let parent = option.parentNode;
    option.addEventListener(`click`, () => {
      parent.classList.toggle(activeClass);
    });
  });
};

/*
 * Account
 */
const populateProvinceSelector = () => {
  const forms = document.querySelectorAll(`.js-address-form`);
  if (!forms.length) return;
  const formatProvinces = (provinceStr, provinceSelect) => {
    if (!provinceStr) return;
    let sanitisedProvinceArray = [];
    provinceStr = provinceStr.substring(1).slice(0, -1);
    if (provinceStr) {
      let provinces = provinceStr.split(`,`);
      let arr = [];
      provinces.forEach((province) => {
        arr.push(province.replace(/[\[\]"]+/g, ``));
      });
      sanitisedProvinceArray = [...new Set(arr)];
    } else {
      sanitisedProvinceArray = [];
    }
    // populate province select field
    if (sanitisedProvinceArray.length) {
      sanitisedProvinceArray.map((p) => {
        let opt = document.createElement('option');
        opt.value = p;
        opt.innerHTML = p;
        provinceSelect.append(opt);
      });
    }
  };
  forms.forEach((form) => {
    const countrySelector = form.querySelector(`.js-country-selector`);
    const provinceSelector = form.querySelector(`.js-province-selector`);
    // set province select list on page load
    let currentOptions = countrySelector.options;
    let currentOptionValue = countrySelector.options[countrySelector.selectedIndex].innerHTML;
    for (let option of currentOptions) {
      if (option.value == currentOptionValue) formatProvinces(option.dataset.provinces, provinceSelector);
    }
    // update province select on country select change
    countrySelector.addEventListener(`change`, (e) => {
      let provinceDataset = e.target.options[e.target.selectedIndex].dataset.provinces;
      provinceSelector.innerHTML = '';
      formatProvinces(provinceDataset, provinceSelector);
    });
  });
};

const toggleModal = () => {
  const modal = document.getElementById(`js-modal`);
  const trigger = document.getElementById(`js-modal-trigger`);
  const close = document.getElementById(`js-modal-close`);
  if (!modal) return;
  trigger.addEventListener(`click`, () => {
    modal.classList.add(activeClass);
  });
  close.addEventListener(`click`, () => {
    modal.classList.remove(activeClass);
  });
};

/*
 * Utils
 */
// const toggleGrid = () => {
//   const gridOverlay = document.getElementById(`js-grid-overlay`)
//   const gridToggle  = document.getElementById(`js-grid-overlay-toggle`)
//   if (!gridOverlay && !gridToggle) return
//   gridToggle.addEventListener(`click`, () => {
//     gridOverlay.classList.toggle(activeClass)
//   })
// }

const cookiePopup = () => {
  const popup = document.getElementById(`js-cookie-popup`);
  const acceptBtn = document.getElementById(`js-cookie-accept`);
  if (!popup) return;
  acceptBtn.addEventListener(`click`, () => {
    popup.classList.remove(activeClass);
    localStorage.setItem(`woset-cookie`, true);
  });
  if (!localStorage.getItem(`woset-cookie`)) {
    setTimeout(() => {
      popup.classList.add(activeClass);
    }, 3000);
  }
};

const mobileNav = () => {
  const trigger = document.getElementById(`js-mobile-nav-btn`);
  const panel = document.getElementById(`js-mobile-nav`);
  const close = document.getElementById(`js-mobile-nav-close`);
  if (!trigger) return;
  trigger.addEventListener(`click`, () => {
    panel.classList.add(activeClass);
    document.body.classList.add(noScroll);
  });
  close.addEventListener(`click`, () => {
    panel.classList.remove(activeClass);
    document.body.classList.remove(noScroll);
  });
};

const scrollHeader = () => {
  const element = document.getElementById('js-scroll-header');
  if (!element) return;
  let lastScrollTop = scrollY;
  window.addEventListener(
    'scroll',
    () => {
      let st = window.scrollY || document.documentElement.scrollTop;
      if (st < lastScrollTop && window.scrollY > 200) {
        // upscroll code
        element.classList.add('is-active');
      } else {
        element.classList.remove('is-active');
      }
      lastScrollTop = st <= 0 ? 0 : st;
    },
    false
  );
};

/*
 * World
 */
const setCharacterIndex = () => {
  const characters = document.querySelectorAll(`.js-character`);
  if (!characters.length) return;
  characters.forEach((character) => {
    character.addEventListener(`click`, (e) => {
      // open panel
      setPanelState(true);
      // init glide instance at index
      updateCharacterCarousel(e.currentTarget.dataset.index);
    });
  });
  closeCharacterPanel();
};

const initCharacterCarousel = () => {
  if (!document.getElementById(`js-character-glide`)) return;
  characterGlideInstance.mount();
};

const updateCharacterCarousel = (index) => {
  characterGlideInstance.update({ startAt: index });
};

const setPanelState = (active) => {
  const panel = document.getElementById(`js-character-panel`);
  if (!panel) return;
  if (active) {
    if (!panel.classList.contains(activeClass)) {
      panel.classList.add(activeClass);
      document.body.classList.add(noScroll);
    } else return;
  } else {
    panel.classList.remove(activeClass);
    document.body.classList.remove(noScroll);
  }
};

const closeCharacterPanel = () => {
  const trigger = document.getElementById(`js-close-panel`);
  if (!trigger) return;
  trigger.addEventListener(`click`, () => {
    setPanelState(false);
  });
};

/*
 * Init
 */
const init = () => {
  // toggleGrid()
  toggleLocale();
  setLocale();
  filterProducts();
  accordion();
  gallery();
  setQuantity();
  setSelectedVariant();
  addToCart();
  // requestAnimationFrame(raf);
  cookiePopup();
  setCharacterIndex();
  initCharacterCarousel();
  quickAddToCart();
  populateProvinceSelector();
  toggleModal();
  mobileNav();
  toggleMobileOptions();
  animateLogo();
  scrollHeader();
};

document.addEventListener(`DOMContentLoaded`, () => {
  init();
  const t = document.getElementById(`js-newsletter-message`);
  let url = new URL(location.href);
  let params = new URLSearchParams(url.search);
  let message = params.get(`customer_posted`);
  if (message) {
    t.style.display = `block`;
    t.textContent = `Subscribed!`;
  }
});
